import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

/**
 * ApplyNow — placeholder page surfaced from the Careers CTA "Apply now"
 * button. Uses the site-wide Navigation + Footer automatically because
 * App.js wraps every Route in <Layout>. Typography mirrors the standard
 * hero treatment (same heading + body text classes used across the site).
 */
const ApplyNow = () => {
  return (
    <section
      data-testid="apply-now-page"
      className="relative min-h-[calc(100vh-64px-200px)] bg-gradient-to-br from-[#E8E4DC] to-[#E8EDE7] flex items-center justify-center overflow-hidden"
    >
      <div className="relative z-10 mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 text-center py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1
            data-testid="apply-now-headline"
            className="text-4xl sm:text-5xl md:text-6xl font-medium text-black/95 mb-4 sm:mb-6"
          >
            Brewing something cool.
          </h1>
          <p
            data-testid="apply-now-subheadline"
            className="text-base sm:text-lg md:text-xl text-black/70 max-w-2xl mx-auto mb-8 sm:mb-10"
          >
            Our application form is being crafted with the same care we put into
            everything else. Check back soon.
          </p>
          <Button
            asChild
            size="lg"
            data-testid="apply-now-back-button"
            className="bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:brightness-105 transition-all text-base px-8"
          >
            <Link to="/careers">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Careers
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default ApplyNow;
